export default __webpack_public_path__ + "static/media/URU.fe5fd03e.svg";